module.exports = __webpack_public_path__ + "static/media/whichThinnerNotAdjusted.db016607.mp3";